import { API_ROOT } from 'environment';

// Keep track of the config at the window level to help app bootstrapping
// Note: the js/app.coffee has to work the injector a bit to help
let lastConfigFromServer = null;

class ConfigService {

    constructor($http, $q) {
        this.$http = $http;
        this.$q = $q;

        // Streaming quality options on account form
        this.streamingQualityLevels = [
            { value: 'sd', label: 'SD - 480 (LEGACY)' },
            { value: 'low_cost', label: 'Low-Cost - 720' },
            { value: '720', label: 'HD - 720' },
            { value: 'hd', label: 'Full HD - 1080' },
            // { value: '4k', label: '4K Ultra HD - 2160' }, // XXX: TODO: Uncomment when 4K is actually supported.
        ];

        // Storage rate options
        this.storageRates = [
            { value: 0.49, label: '$0.49 / broadcast-hr' },
            { value: 0.25, label: '$0.25 / broadcast-hr' },
        ];

        // Max Broadcast Duration options
        this.maxBroadcastDurations = [
            { value: 1, label: '1 Hour' },
            { value: 3, label: '3 Hours' },
            { value: 8, label: '8 Hours' },
            { value: 24, label: '24 Hours' },
        ];

        // Ticket revenue share options
        this.ticketRevenueShareOptions = [
            { value: "75", label: '75 Customer / 25 BoxCast (Default)' },
            { value: "25", label: '25 Customer / 75 BoxCast' },
            { value: "50", label: '50 Customer / 50 BoxCast' },
            { value: "60", label: '60 Customer / 40 BoxCast' },
            { value: "85", label: '85 Customer / 15 BoxCast' },
        ];

        // Roles available for user permissioning
        this.userRoles = [];
        // Roles available for admin user permissioning
        this.adminRoles = [];
        this.boxcaster = {};
        this.accountTags = [];
        this.accountTagsByCategory = {};
        this.updateFromApi();
    }

    updateFromApi() {
        if (lastConfigFromServer) {
            let deferred = this.$q.defer();
            this.storeApiResult(lastConfigFromServer, this);
            deferred.resolve();
            return this.promise = deferred.promise;
        } else {
            let self = this;
            return this.promise = this.$http.get(`${API_ROOT}/api_configuration`).then((res) => self.storeApiResult(res, self));
        }
    }

    storeApiResult(c, self) {
        lastConfigFromServer = c;

        self.accountTags = c.data.account.feature_flags;
        self.accountTagsByCategory = {};
        let categories = _.sortBy(_.uniq(_.pluck(self.accountTags, 'category')), c => c);
        _.each(categories, category => {
            let categoryTags = [];
            _.each(self.accountTags, tag => {
                if (tag.category === category) {
                    categoryTags.push(tag)
                }
            });
            self.accountTagsByCategory[category] = _.sortBy(categoryTags, tag => tag.label);
        });

        self.extraFeatures = c.data.account.extra_features;
        self.usageFlags = c.data.account.usage_flags;
        self.behaviorModifications = c.data.account.behavior_modifications;
        self.markets = angular.copy(c.data.account.markets);
        self.markets.push({value: "unknown", label: "Unknown"});
        self.contractTypes = c.data.account.contract_types;
        self.accountStatuses = c.data.account.statuses;
        self.paymentStatuses = c.data.account.payment_statuses;
        self.paymentMethods = c.data.account.payment_methods || [];
        self.storagePolicies = c.data.account.storage_policies;
        self.supportPlans = c.data.account.support_plans;
        self.boxcaster = c.data.boxcaster;
        self.backhaulProtocols = self.boxcaster.backhaul_protocols;
        self.userRoles = c.data.user_roles;
        self.adminRoles = c.data.admin_roles;
        self.roles = self.userRoles.concat(self.adminRoles)
        return self.timeZones = c.data.time_zones;
    }
}

angular.module('app.services').service('Config', ConfigService);



// WEBPACK FOOTER //
// ./services/config.js